import { Operator } from '~/components/Filters/Primitive/Date/types.flow';

export const OPERATOR = {
  EQUALS: 'eq',
  GREATER_THAN: 'gt',
  LESS_THAN: 'lt',
  GREATER_THAN_EQUAL: 'gte',
  LESS_THAN_EQUAL: 'lte',
};

export const operatorOptions = [
  {
    key: Operator.EQUALS,
    payload: Operator.EQUALS,
    label: 'Op',
  },
  {
    key: Operator.GREATER_THAN_EQUAL,
    payload: Operator.GREATER_THAN_EQUAL,
    label: 'Vanaf',
  },
  {
    key: Operator.LESS_THAN_EQUAL,
    payload: Operator.LESS_THAN_EQUAL,
    label: 'Tot en met',
  },
];
